module.exports = __webpack_public_path__ + "static/media/Mark Gabriel.c634ee78.png";